import './thecliffshotel2/style';
import FormStructure from './thecliffshotel2/form_structure';

export default FormStructure;



// WEBPACK FOOTER //
// C:/Users/adrienn.bonnyai/Web-Inquiry/inquiry-renderer/client_forms/includes.js